<!--
 * @Description:
 * @Date: 2018-12-21 17:03:28
 -->
<template>
  <div class="revise-password">
    <modal-base
      :title="diaLogTitle(nowStep)"
      :back="false"
      @callback="callback"
      :hideBtn="hideBtn"
      :confirmText="confirmText"
    >
      <div class="revise-password-dialog-body" slot="content">
        <el-form
          class="revise-password-form"
          :model="modelForm[nowStep]"
          status-icon
          ref="ruleForm"
          v-if="nowStep < 2"
        >
          <el-form-item
            :prop="item.key"
            v-for="(item, index) in form[nowStep]"
            :key="`form-${index}`"
            :rules="item.rule"
          >
            <el-input
              :prefix-icon="item.icon"
              class="input"
              :type="item.type"
              v-model="modelForm[nowStep][item.key]"
              autocomplete="off"
              :placeholder="item.placeholder"
              :disabled="item.disable"
            >
              <template slot="append" v-if="item.slot == 'imgYzm' && phoneIsOk">
                <div class="yzm-img">
                  <img :src="imgUrl" class="imgVerify" @click="changeEwm" />
                </div>
              </template>
              <template
                slot="append"
                v-if="item.slot == 'sendMsg' && phoneIsOk"
              >
                <div class="send-msg">
                  <XrkSlideVerify
                    ref="verification"
                    :options="verificationOptions"
                    @success="checkSuccessful"
                    @close="verifyClose"
                  >
                    <msgCode
                      ref="getMsgBtn"
                      style="position: absolute;left: 20px"
                      :phone="modelForm[nowStep]['phone']"
                      :imgCode="modelForm[nowStep]['captcha']"
                      :getMsgCodeFn="ajaxSendMsgCode"
                      @getMsg="showVerification"
                      @error="changeEwm"
                    ></msgCode>
                  </XrkSlideVerify>
                </div>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <div v-else class="revise-success">
          <img class="icon" :src="successIcon" alt />
          <div class="text">密码修改成功</div>
          <div class="tips">请重新登录，{{ time }}s</div>
        </div>
      </div>
    </modal-base>
  </div>
</template>

<script>
import modalBase from './modalBase1.vue';
import { getVerification, login } from '@/api/ajax';
import msgCode from './msgCode.vue';
import { getStorage } from '@/tools/storage';

const normalValidator = (rule, value, callback, errTip) => {
  if (`${value}`.length == 0) {
    callback(new Error(errTip));
  } else {
    callback();
  }
};
export default {
  name: 'revisePassword',
  components: { msgCode, modalBase },
  props: {
    ajaxGetMsgCode: {
      type: [Function, String],
      default: login.sendMessageCode
    },
    ajaxGetImgCode: {
      type: [Function, String],
      default: login.verifyImgCode
    }
  },
  data() {
    return {
      verificationOptions: {
        // 接口请求 防抖
        remoteTimerInterval: 800,
        errorText: '请控制拼图块对齐缺口',
        successText: '验证成功',
        remoteApi: {
          initImages: getVerification,
          checkVerification: position => {
            return login.sendMessageCode({
              phone: this.modelForm[this.nowStep]['phone'],
              ...position
            });
          }
        },
        errorAnimationDuration: 800
      },
      successIcon: require('@/assets/img/renzhengchenggong.svg'),
      nowStep: 0,
      showDialog: true,
      formAllData: [
        {
          step: 0,
          label: '手机号码',
          placeholder: '请输入手机号码',
          key: 'phone',
          type: '',
          val: getStorage('user')['phone'],
          icon: 'el-icon-mobile-phone',
          disable: true,
          rule: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (!/^1\d{10}$/.test(value)) {
                  `${value}`.length == 0
                    ? callback(new Error('手机号码不能为空'))
                    : callback(new Error('请输入正确的手机号'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            },
            {
              required: true,
              validator: (rule, value, callback) => {
                if (/^1\d{10}$/.test(value)) {
                  this.changeEwm(value);
                  this.phoneIsOk = true;
                  callback();
                } else {
                  this.phoneIsOk = false;
                }
              },
              trigger: 'change'
            }
          ]
        },
        // {
        //   step: 0,
        //   label: "图形验证码",
        //   placeholder: "请输入图形验证码",
        //   key: "captcha",
        //   val: "",
        //   slot: "imgYzm",
        //   icon: "el-icon-picture",
        //   rule: [
        //     {
        //       required: true,
        //       validator: (rule, value, callback) => {
        //         if (`${value}`.length < 4) {
        //           callback(new Error("图形验证码不能小于4位"));
        //         } else {
        //           callback();
        //         }
        //       },
        //       trigger: "blur"
        //     }
        //   ]
        // },
        {
          step: 0,
          label: '短信验证码',
          placeholder: '请输入短信验证码',
          key: 'code',
          val: '',
          slot: 'sendMsg',
          icon: 'el-icon-message',
          rule: [
            {
              required: true,
              validator: (rule, value, callback) => {
                normalValidator(rule, value, callback, '短信验证码不能为空');
              }
              // trigger: 'blur'
            }
          ]
        },
        {
          step: 1,
          label: '重置密码',
          type: 'password',
          placeholder: '请输入密码',
          key: 'pwd',
          icon: 'el-icon-picture',
          rule: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (`${value}`.length == 0) {
                  callback(new Error('密码不能为空'));
                } else if (
                  !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,16}$/.test(value)
                ) {
                  callback(new Error('密码只能使用数字和字母组合,4到16位'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          val: ''
        },
        {
          step: 1,
          label: '确认密码',
          type: 'password',
          placeholder: '请再次输入密码',
          key: 'pwd_sure',
          icon: 'el-icon-picture',
          rule: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (`${value}`.length == 0) {
                  callback(new Error('密码不能为空'));
                } else if (
                  !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,16}$/.test(value)
                ) {
                  callback(new Error('密码只能使用数字和字母组合,4到16位'));
                }
                if (value != this.modelForm[this.nowStep]['pwd']) {
                  callback(new Error('两次输入密码不一样'));
                }
                callback();
              },
              trigger: 'blur'
            }
          ],
          val: ''
        }
      ],
      steps: [
        {
          title: '验证手机号',
          nextBtn: {
            text: '下一步',
            fn: () => {
              this.nextStep();
            }
          },
          description: ''
        },
        {
          title: '重置密码',
          nextBtn: {
            text: '下一步',
            fn: () => {
              this.nextStep();
            }
          },
          description: ''
        },
        {
          title: '修改成功',
          nextBtn: null,
          description: ''
        }
      ],
      form: [],
      modelForm: [],
      imgUrl: '',
      ajaxSendMsgCode: getVerification,
      show: false,
      phoneIsOk: true,
      time: 5
    };
  },
  computed: {
    nowStepBtn() {
      return this.steps[this.nowStep] && this.steps[this.nowStep]['nextBtn'];
    },
    diaLogTitle(step) {
      return step => {
        const arr = ['验证手机', '重置密码', '修改成功'];
        return arr[step] || '修改成功';
      };
    },
    confirmText() {
      return this.nowStep < 2 ? '下一步' : '确认';
    },
    hideBtn() {
      return this.nowStep > 1;
    }
  },
  methods: {
    // 显示 滑块验证
    showVerification() {
      this.$refs['verification'][0].visible = true;
    },
    checkSuccessful() {
      this.$refs['getMsgBtn'][0].runTimer();
    },
    verifyClose() {},
    // 初始化表单 数据 输入
    initFormData(dataArr) {
      const obj = {};
      const modelObj = {};
      dataArr.forEach(item => {
        const modelObjPre = modelObj[item.step] || {};
        modelObjPre[item.key] = item.val;
        if (obj[item.step]) {
          obj[item.step].push(item);
        } else {
          obj[item.step] = [item];
        }
        modelObj[item.step] = modelObjPre;
      });
      for (let i in obj) {
        this.$set(this.form, parseInt(i), obj[i]);
        this.$set(this.modelForm, parseInt(i), modelObj[i]);
      }
      this.show = true;
    },
    back() {
      const nowStep = parseInt(this.nowStep);
      const that = this;
      if (nowStep > 0) {
        this.$confirm('是否放弃重置密码操作')
          .then(() => {
            that.$router.back();
          })
          .catch(() => {});
        return;
      }
      that.$router.back();
    },
    clearValidate() {
      this.$refs['ruleForm'].clearValidate();
    },
    backStep() {
      this.clearValidate();
      this.nowStep = this.nowStep - 1;
    },
    nextStep(step = 1) {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          if (this.nowStep == 0) {
            this.validatePhone(
              this.modelForm[0]['phone'],
              this.modelForm[0]['code']
            ).then(() => {
              this.showNext(step);
            });
          } else if (this.nowStep == 1) {
            this.resetPwd(
              this.modelForm[0]['phone'],
              this.modelForm[0]['code'],
              this.modelForm[1]['pwd'],
              this.modelForm[1]['pwd_sure']
            ).then(() => {
              this.showNext(step);
              this.reviseSuccess();
            });
          }
        } else {
          return false;
        }
      });
    },
    showNext(step) {
      this.show = false;
      this.nowStep = this.nowStep + step;
      setTimeout(() => {
        this.show = true;
      }, 50);
      this.clearValidate();
    },
    validatePhone(phone, verifyCode) {
      return new Promise(resolve => {
        login
          .validatePhoneAndSmscodeForResetPassword({
            phone,
            verifyCode
          })
          .then(() => {
            resolve('ok');
          });
      });
    },
    resetPwd(phone, verifyCode, pwd) {
      return new Promise(resolve => {
        const password = pwd;
        const confirm = this.confirmPwd;
        login
          .resetUserPwd({
            phone,
            password,
            confirm,
            verifyCode
          })
          .then(() => {
            resolve('ok');
          });
      });
    },
    changeEwm(phone = getStorage('user')['phone']) {
      //更换二维码
      this.imgUrl = `${this.ajaxGetImgCode}?phone=${phone}&v=${+new Date()}`;
    },
    async reviseSuccess() {
      localStorage.clear();
      sessionStorage.clear();
      const timer = setInterval(() => {
        this.time = this.time - 1;
        if (this.time <= 0) {
          clearInterval(timer);
          const route = this.$router.resolve({
            name: 'login'
          });
          window.location.reload(route.href);
        }
      }, 1000);
    },
    callback(type) {
      if (type == 'success') {
        this.nextStep();
      } else {
        this.$parent.componentName = '';
        // this.$emit("close");
      }
    }
  },
  created() {
    this.initFormData(this.formAllData);
    if (this.phoneIsOk) {
      this.changeEwm();
    }
  },
  beforeDestroy() {},
  filters: {}
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.revise-password {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background: #fff;
  .revise-password-dialog-body {
    width: 100%;
  }
  .step-block {
    cursor: default;
    user-select: none;
    width: 700px;
    margin-top: 120px;
    margin-bottom: 40px;
  }
  .revise-password-form {
    width: 100%;
    .yzm-img {
      width: 104px;
      img {
        width: 104px;
        height: 42px;
      }
    }
    .send-msg {
      width: 104px;
      height: 42px;
      display: flex;
      position: relative;
      //overflow: hidden;
    }
    .el-form-item {
      margin-bottom: 35px;
      .input {
        border: none;
        height: 52px;
      }
    }
  }
  .revise-success {
    text-align: center;
    .icon {
      width: 128px;
      height: 128px;
    }
    .text {
      font-size: 18px;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
      line-height: 20px;
      margin-top: 15px;
      letter-spacing: 1px;
    }
    .tips {
      font-size: 14px;
      font-weight: 400;
      color: rgba(191, 191, 191, 1);
      line-height: 14px;
      margin-top: 30px;
      letter-spacing: 1px;
    }
  }
}
</style>
<style scoped>
/*.v-box_box {*/
/*  top: 0 !important;*/
/*  right: 0 !important;*/
/*  bottom: 0 !important;*/
/*  left: 0 !important;*/
/*  margin: auto !important*/
/*}*/
</style>
<style lang="scss">
.revise-password {
  .el-input-group__append {
    padding: 0;
  }

  .revise-password-dialog {
    border-radius: 12px;

    .el-dialog__header {
      padding-top: 30px;
    }
  }
  .el-input__inner {
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 0;
  }
  .el-input__prefix {
    .el-input__icon {
      font-size: 20px;
    }
  }
  .el-input--prefix .el-input__inner {
    padding-left: 40px;
    height: 52px;
  }
  .el-input-group__append {
    background: none;
    border: none;
    position: absolute;
    right: 0;
    top: 5px;
    width: 104px;
    height: 42px;
  }
}
</style>
